import { Component, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { StatusSelectFieldComponent } from '../fields/status-select-field/status-select-field.component';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { SeveritySelectFieldComponent } from '../fields/severity-select-field/severity-select-field.component';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';

@Component({
  selector: 'app-problem-record-problem-info-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SeveritySelectFieldComponent,
    StatusSelectFieldComponent,
    TranslateModule,
    DatepickerFormFieldComponent,
  ],
  templateUrl: './problem-record-problem-info-form.component.html',
  styleUrl: './problem-record-problem-info-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class ProblemRecordProblemInfoFormComponent {
  @Input() problemPriorityItems: any[] = [];
  
  form: any;
  viewMode = true;
  statusItems: any = [];

  constructor(
    public mainForm: FormGroupDirective,
    private configurationService: ConfigurationService
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.getStatusItems();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('problemStatus', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('problemPriority', new FormControl(null, []));
    this.form.addControl('verifyDate', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('closedDate', new FormControl({ value: null, disabled: true }, []));

  }

  getStatusItems() {
    this.statusItems = this.configurationService.getProblemRecordStatusItems();
  }
}
